import React, { useEffect, useState } from 'react'
import style from 'styled-components';
import Title from '../components/Layout/Title';
import InputMask from 'react-input-mask';
import Format from '../components/Layout/Format/index';
import Button from '../components/Layout/Button/index'
import {useDispatch,useSelector} from 'react-redux';
import { FetchOrder } from '../Actions/orderAction';
import { useHistory } from "react-router-dom";



const Container = style.div`
  display:flex;
  flex-direction:row;
  gap:0.5rem;
  margin-top:3.0rem;
  justify-content:space-around;
  width:100%;
  @media(max-width:800px){
    flex-direction:column;
  }
`;

const Form = style.form`
display: flex;
flex-direction: column;
align-items:center;
box-shadow:1px 1px 1px black;
width: 20%;
border:1px solid black;
text-align:center;
@media(max-width:800px){
  width:auto;
}
`

const Input = style(InputMask)`
background-color: ${({ theme }) => theme.colors.black};
height: auto;
margin:1.0rem;
width:80%;
font-size:1.5rem;
text-align:center;
&:focus {
  outline: none;
}
`

const Body = style.div`
display: flex;
flex-direction: column;
align-items:center;
box-shadow:1px 1px 5px black;
width: 40%;
border:1px solid black;
@media(max-width:800px){
    width:auto;
  }
`
const Prices = style.div`
   display:flex;
   flex-direction:column;
   gap:0.5rem;
   background:lightgray;
   padding:2.0rem;
`
const Span = style.span`
   margin-right:2.0rem;
`;

const SumaryProducts = style.div`
   display:flex;
   flex-direction:column;
   margin-top:3.0rem;
   div{
       display:flex;
       flex-direction:row;
       justify-content:center;
       div{
           display:flex;
           flex-direction:column;
           span{
               font-size:${({ theme }) => theme.fontSizes.small};
               margin:0.4rem;
           }
       }
   }
`;


export default function Order() {

    const { cartItems,Total } = useSelector((state) => state.cart)
    const { orderOk } = useSelector((state) => state.order)
    const dispatch = useDispatch()
    const history = useHistory()
    const [erros,setErros] = useState("")
    const [delivery, setDelivery] = useState({
        fullName:"",
        postalCode:"",
        address:"",
        city:"",
        country:""
    });
    const [TotalPrice,setTotalPrice] = useState(0)
    const shipping = 50

    useEffect(()=>{
       setTotalPrice(Total+shipping) 
    },[Total])
    
    const onSubmit = (event)=>{
        event.preventDefault()
        if(!delivery.fullName || !delivery.postalCode || !delivery.address || !delivery.city || !delivery.country){
          setErros("Please Complete the form")
        }else{
            dispatch(FetchOrder(delivery,TotalPrice,shipping))
        }
    } 

    useEffect(()=>{
        if(orderOk){
            history.push("/confirmOrder")
         }
    },[orderOk])

    return (
        <Container>
                  <Form onSubmit={onSubmit}>
                       <Title>Basic Information</Title>
                        {
                        erros && <p style={{color:"red"}}>{erros}</p>
                        }
                      <Input name="fullName"  onChange={e => setDelivery({...delivery,[e.target.name]:e.target.value})} placeholder="Full Name"/>
                      <Input name="postalCode" onChange={e => setDelivery({...delivery,[e.target.name]:e.target.value})}  mask="99-999-999" placeholder="Cep/Zip Code"/>
                      <Input name="address"  onChange={e => setDelivery({...delivery,[e.target.name]:e.target.value})} placeholder="Address"/>
                      <Input name="city"  onChange={e => setDelivery({...delivery,[e.target.name]:e.target.value})} placeholder="City"/>
                      <Input name="country"  onChange={e => setDelivery({...delivery,[e.target.name]:e.target.value})} placeholder="Country"/>
                      <Button color="gray" ty="submit">Submit</Button>
                  </Form>
                  <Body>
                      <Title>Summary</Title>
                      <Prices>
                      <span>
                          <Span>Price</Span>
                          <Format price={Total}/></span>
                      <span><Span>Shipping</Span><Format price={shipping}/></span>
                      <span><Span>Total</Span><Format price={TotalPrice}/></span>
                      </Prices>
                      
                      <hr style={{border:"1px solid black",width:"100%"}}/>
                          <SumaryProducts>
                              {cartItems.map(cartItems =>(
                              <div key={cartItems._id}>
                              <img alt="cart-img" src={cartItems.image} style={{height:"50px",width:"50px"}} />
                              <div>
                              <span>{cartItems.title}</span>
                              <span>preço:<Format price={cartItems.price}/></span>
                              </div>
                              </div>
                            ))}
                          </SumaryProducts>
                  </Body>       
              
        </Container>
    )
}
